import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/countries')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/countries/${id}`)
    return data
  },

  async create(countryData) {
    const { data } = await api.post('/admin/countries', countryData)
    return data
  },

  async update(id, countryData) {
    const { data } = await api.put(`/admin/countries/${id}`, countryData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/countries/${id}`)
    return data
  }
}

